import { render, staticRenderFns } from "./SendNotificationInDialog.vue?vue&type=template&id=589b83cf&scoped=true"
import script from "./SendNotificationInDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SendNotificationInDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SendNotificationInDialog.vue?vue&type=style&index=0&id=589b83cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b83cf",
  null
  
)

export default component.exports